<template>
  <div class="card is-multiline">
    <div class="hoverCardHeader">
      <div class="card-header-title pd-0 columns is-marginless is-justify-content-space-between"
           :class="index % 2 === 0 ? 'stripped' : ''">
        <div class="column is-narrow ellipsis">
          <div class="columns">
            <div class="column is-4" v-if="afficherCheckbox">
              <qd-checkbox :value="emplacement.selected" class="mgt-5px"
                          :indeterminate="activateIndeterminate"
                          @input="selectAllChild"></qd-checkbox>
            </div>
              <div class="column has-text-cent is-4 is-cursor-pointer"
                   :class="emplacement.dispositifs.length > 0 ? '' : 'disabled'"
                   @click="emplacement.open = !emplacement.open">
                <b-icon :icon="emplacement.open
                ? 'chevron-up' : 'chevron-down'" class="mgt-5px">
                </b-icon>
            </div>
          </div>
        </div>
        <div class="column is-2 ellipsis">
          <div class="columns">
          <div class="column is-narrow pdh-0has-text-weight-bold">
            {{ $t('emplacementDispositifMaterielFacePicker.tab.emplacement') }}
          </div>
          <div class="column is-5">
            <router-link-blank class="ellipsis"
              :to="{ name: 'c.gabed.emplacement-detailEmplacement',
                           params: { id: emplacement.id }}"
              :message="emplacement.code"
            />
          </div>
          </div>
        </div>
        <div class="column is-1 has-text-default min-width-type">
          <div class="columns">
            <div class="column is-2 has-text-centered pdr-0 pdl-0
            mgr-10px">
              <img :src="getLogoEmplcament(emplacement.type)" alt="">
            </div>
            <div class="column is-10 pdl-0 ellipsis">
              {{ $t(getTypeEmplacement(emplacement.type)) }}
            </div>
          </div>
        </div>
        <div class="column is-2 ellipsis has-text-default">
          {{ emplacement.libelle }}
        </div>
        <div class="column has-text-default ellipsis is-4">
          <p class="ellipsis">{{ getAdresse(emplacement.adresseCadastrale) }}</p>
        </div>
        <div class="column is-1 has-text-right">
            <b-tag type="has-background-subMenu" class="has-text-white" v-if="!emplacement.actif">
              {{$t('emplacementDispositifMaterielFacePicker.archive')}}
            </b-tag>
          </div>
      </div>
    </div>

    <div class="card-content width-100percent pd-10px"
         v-if="emplacement.open && emplacement.dispositifs && emplacement.dispositifs.length > 0">
      <ligne-dispositif :dispositif="dispositif"
                        :afficherAffectation="afficherAffectation"
                        :emplacementId="emplacement.id"
                        :selectOnlyOneObject="selectOnlyOneObject"
                        :dateDebut="dateDebut"
                        @dispositifSelected="checkEmplacementMustBeSelectedOrNot"
                        @passToFalse="$emit('passToFalse', $event)"
                        :dateFin="dateFin"
                        :index="index"
                        :afficherCheckboxMateriel="afficherCheckboxMateriel"
                        :afficherCheckboxFace="afficherCheckboxFace"
                        :afficherCheckbox="afficherCheckboxDispositif"
                         v-for="(dispositif, index) in emplacement.dispositifs" :key="index"
                         :displayInactif="displayInactif"
                         v-show="displayInactif || dispositif.actif">
      </ligne-dispositif>
    </div>
  </div>
</template>

<script>

import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { TYPE_EMPLACEMENT } from '@/configuration/gabed/emplacement/emplacementConf';
import ligneDispositif from '@/components/gabed/general/ligneDispositif';

export default {
  name: 'ligneEmplacement',
  props: {
    index: {
      required: true,
      default: 0,
      type: Number,
    },
    emplacement: {
      required: false,
      default: null,
      type: Object,
    },
    dateDebut: {
      required: false,
      type: Date,
      default() {
        return new Date();
      },
    },
    dateFin: {
      required: false,
      type: Date,
      default() {
        return new Date();
      },
    },
    afficherAffectation: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckbox: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxMateriel: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxFace: {
      required: false,
      type: Boolean,
      default: true,
    },
    selectOnlyOneObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    afficherCheckboxDispositif: {
      type: Boolean,
      default: true,
    },
    displayInactif: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    routerLinkBlank,
    ligneDispositif,
  },
  computed: {
    activateIndeterminate() {
      if (this.emplacement.selected) return false;
      return this.emplacement.dispositifs && this.emplacement.dispositifs.some((dispositif) => {
        const hasSelectionMateriel = dispositif.materiels
          && dispositif.materiels.some((materiel) => {
            const hasFaceSelectionne = materiel.faces && materiel.faces.some((face) => {
              return face.selected;
            });
            return materiel.selected || hasFaceSelectionne;
          });
        return dispositif.selected || hasSelectionMateriel;
      });
    },
  },
  methods: {
    checkEmplacementMustBeSelectedOrNot() {
      this.emplacement.selected = this.emplacement.dispositifs
        .filter((dispositif) => { return dispositif.selected; }).length
        === this.emplacement.dispositifs.length && this.emplacement.dispositifs.length > 0;
    },
    selectAllChild(newStatus) {
      if (this.selectOnlyOneObject) this.$emit('passToFalse', this.emplacement.id);
      this.emplacement.selected = newStatus;
      this.emplacement.dispositifs.forEach((dispositif) => {
        dispositif.selected = this.selectOnlyOneObject ? false : newStatus;
        dispositif.materiels.forEach((materiel) => {
          materiel.selected = this.selectOnlyOneObject ? false : newStatus;
          materiel.faces.forEach((face) => {
            face.selected = this.selectOnlyOneObject ? false : newStatus;
          });
        });
      });
    },
    getAdresse(adresse) {
      return adressFullStringGetter(adresse);
    },
    getLogoEmplcament(type) {
      return TYPE_EMPLACEMENT.find((typeEmplacement) => {
        return typeEmplacement.name === type;
      }).icon;
    },
    getTypeEmplacement(type) {
      return TYPE_EMPLACEMENT.find((typeEmplacement) => {
        return typeEmplacement.name === type;
      }).libelle;
    },
    openEmplacement() {
      if (this.emplacement && this.emplacement.dispositifs.length > 0) {
        this.emplacement.open = true;
        this.emplacement.dispositifs.forEach((dispositif) => {
          if (dispositif.materiels.length > 0) {
            dispositif.open = true;
            dispositif.materiels.forEach((mat) => { if (mat.faces.length > 0) mat.open = true; });
          }
        });
      }
    },
  },
  mounted() {
    this.checkEmplacementMustBeSelectedOrNot();
    this.openEmplacement();
  },
};
</script>

<style scoped>

</style>
